// https://github.com/lazaronixon/trix-extensions
// https://github.com/basecamp/trix/issues/1055
import { Controller } from "@hotwired/stimulus"
import Trix from 'trix'
import { post } from '@rails/request.js'

// Connects to data-controller= "trix-articles"
export default class extends Controller {
	initialize() {
		// For multiple Image Url attachments
		this.imageActionId = Math.random().toString(36)
		this.imageDialogId = Math.random().toString(36)
		this.imageCustomId = Math.random().toString(36)
		this.imageInputId = Math.random().toString(36)
		// For multiple Custom Quotes attachments
		this.quoteActionId = Math.random().toString(36)
		this.quoteDialogId = Math.random().toString(36)
		this.quoteCustomId = Math.random().toString(36)
		this.quoteInputId = Math.random().toString(36)
		this.toolbarElement = this.element.toolbarElement
		// Removing file attachment button
		this.removeButtons()
		// For custom h1 - h6 Headers
		this.insertHeadingElements()
		this.addHeadingAttributes()
		// For Image Url button
		this.addImageUrlButton()
		this.addImageUrlDialog()
		// For Custom Quote Button
		this.addQuoteButton()
		this.addQuoteDialog()
	}

	connect() {
		// For Image Url attachments
		this.eventListenerForImageUrlButton()
		this.eventListenerForImageAddButton()
		// For Inserting Custom HTML for Blockquote
		this.eventListenerForQuoteButton()
		this.eventListenerForQuoteAddButton()
		// Prevents file uploads
		this.eventListenerForFileAccept()
	}

	removeButtons() {
		const file_tools = this.toolbarElement.querySelector("[data-trix-button-group='file-tools']");
		file_tools.remove();
		const heading_button = this.toolbarElement.querySelector("[data-trix-attribute='heading1']")
		heading_button.remove();
		const quote = this.toolbarElement.querySelector("[data-trix-attribute='quote']");
		quote.remove();
	}

	// For custom h1 - h6 Headers
	insertHeadingElements() {
		this.insertNewHeadingButton()
		this.insertHeadingDialog()
	}

	addHeadingAttributes() {
		Array.from(["h1", "h2", "h3", "h4", "h5", "h6"]).forEach((tagName, i) => {
			Trix.config.blockAttributes[`heading${(i + 1)}`] = { tagName: tagName, terminal: true, breakOnReturn: true, group: false }
		})
	}

	insertNewHeadingButton() {
		const heading_button = this.toolbarElement.querySelector("[data-trix-button-group='block-tools']")
		heading_button.insertAdjacentHTML("afterbegin", this.headingButtonTemplate)
	}

	insertHeadingDialog() {
		const heading_dialog = this.toolbarElement.querySelector("[data-trix-dialogs]")
		heading_dialog.insertAdjacentHTML("beforeend", this.dialogHeadingTemplate)
	}

	get headingButtonTemplate() {
		return '<button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-action="x-heading" title="Heading" tabindex="-1">Heading</button>'
	}

	get dialogHeadingTemplate() {
		return `
          <div class="trix-dialog trix-dialog--heading" data-trix-dialog="x-heading" data-trix-dialog-attribute="x-heading">
            <div class="trix-dialog__link-fields">
                <input type="text" name="x-heading" class="trix-dialog-hidden__input" data-trix-input>
                <div class="trix-button-group">
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading1">H1</button>
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading2">H2</button>
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading3">H3</button>
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading4">H4</button>
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading5">H5</button>
                  <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading6">H6</button>
                </div>
            </div>
          </div>
      `
	}

	// For Image Url button
	addImageUrlButton() {
		const buttonHTML = '<button type="button" id="' + this.imageActionId + '" class="trix-button" data-trix-attribute="imageUrl" data-trix-action="imageUrl" data-trix-media-plugin-target="button" title="ImageUrl" tabindex="-1">Image URL</button>'
		const buttonGroup = this.toolbarElement.querySelector(".trix-button-group--block-tools")
		buttonGroup.insertAdjacentHTML("beforeend", buttonHTML)
	}

	addImageUrlDialog() {
		const dialogHTML = `<div class="trix-dialog trix-dialog--link" id="` + this.imageDialogId + `" data-trix-dialog="imageUrl" data-trix-dialog-attribute="imageUrl">
                                <div class="trix-dialog__link-fields">
                                    <input type="text" id="` + this.imageInputId + `" name="imageUrl" class="trix-input trix-input--dialog" placeholder="Paste image URL from S3 or other object storage services." aria-label="imageUrlCode" disabled="disabled">
                                    <div class="trix-button-group">
                                        <input type="button" class="trix-button trix-button--dialog" id="` + this.imageCustomId + `" data-trix-custom="add-imageUrl" value="Add">
                                    </div>
                                </div>
                            </div>`
		const dialogGroup = this.toolbarElement.querySelector(".trix-dialogs")
		dialogGroup.insertAdjacentHTML("beforeend", dialogHTML)
	}

	eventListenerForImageUrlButton() {
		document.getElementById(this.imageActionId).addEventListener("click", event => {
			const dialog = document.getElementById(this.imageDialogId)
			const urlInput = document.getElementById(this.imageInputId)
			if (event.target.classList.contains("trix-active")) {
				event.target.classList.remove("trix-active");
				dialog.classList.remove("trix-active");
				delete dialog.dataset.trixActive;
				urlInput.setAttribute("disabled", "disabled");
			} else {
				event.target.classList.add("trix-active");
				dialog.classList.add("trix-active");
				dialog.dataset.trixActive = "";
				urlInput.removeAttribute("disabled");
				urlInput.focus();
			}
		})
	}

	eventListenerForImageAddButton() {
		document.getElementById(this.imageCustomId).addEventListener("click", event => {
			const url = document.getElementById(this.imageInputId).value
			if (url) {
				this.addImageUrl(url)
			}
		})
	}

	addImageUrl(url) {
		let _this = this
		const attachment = new Trix.Attachment({ url: url, contentType: "image/png/svg" })
		_this.element.editor.insertAttachment(attachment)
		_this.element.editor.insertLineBreak()
	}

	// For blockquote customization
	addQuoteButton() {
		const buttonHTML = '<button type="button" id="' + this.quoteActionId + '" class="trix-button" data-trix-attribute="customQuote" data-trix-action="customQuote" title="customQuote" tabindex="-1">CQ</button>'
		const buttonGroup = this.toolbarElement.querySelector(".trix-button-group--block-tools")
		buttonGroup.insertAdjacentHTML("beforeend", buttonHTML)
	}

	addQuoteDialog() {
		const dialogHTML = `<div class="trix-dialog trix-dialog--link" id="` + this.quoteDialogId + `" data-trix-dialog="customQuote" data-trix-dialog-attribute="customQuote">
                          <div class="trix-dialog__link-fields">
                            <textarea id="` + this.quoteInputId + `" name="customQuote" class="trix-input trix-input--dialog" placeholder="Add texts for a blockquote." aria-label="customQuoteCode" disabled="disabled"></textarea>
                            <div class="trix-button-group">
                              <input type="button" class="trix-button trix-button--dialog" id="` + this.quoteCustomId + `" data-trix-custom="add-customQuote" value="Add">
                            </div>
                          </div>
                        </div>`
		const dialogGroup = this.toolbarElement.querySelector(".trix-dialogs")
		dialogGroup.insertAdjacentHTML("beforeend", dialogHTML)
	}

	eventListenerForQuoteButton() {
		document.getElementById(this.quoteActionId).addEventListener("click", event => {
			const dialog = document.getElementById(this.quoteDialogId)
			const blockquoteInput = document.getElementById(this.quoteInputId)
			if (event.target.classList.contains("trix-active")) {
				event.target.classList.remove("trix-active");
				dialog.classList.remove("trix-active");
				delete dialog.dataset.trixActive;
				blockquoteInput.setAttribute("disabled", "disabled");
			} else {
				event.target.classList.add("trix-active");
				dialog.classList.add("trix-active");
				dialog.dataset.trixActive = "";
				blockquoteInput.removeAttribute("disabled");
				blockquoteInput.focus();
			}
		})
	}

	eventListenerForQuoteAddButton() {
		document.getElementById(this.quoteCustomId).addEventListener("click", event => {
			const content = document.getElementById(this.quoteInputId).value
			if (content) {
				this.insertQuote(content)
			}
		})
	}

	async insertQuote(content) {
		let _this = this
		let formData = new FormData()
		formData.append("content", content)
		const response = await post('/utilities/blockquote', { body: formData, responseKind: "json" })
		if (response.ok) {
			const data = response.json
			data.then((result) => {
				const attachment = new Trix.Attachment(result)
				_this.element.editor.insertAttachment(attachment)
				_this.element.editor.insertLineBreak()
			})
		}
	}

	eventListenerForFileAccept() {
		document.addEventListener("trix-file-accept", function (e) {
			e.preventDefault();
		})
	}
}